// =====================================================================
// Revendo: Checkout-Add-ons-Modal (Garantieverlängerung + Zubehör)
// Beim Klick auf "Auschecken" im Side-Cart öffnet ein Modal mit Garantie-
// und Zubehör-Optionen (Displayschutz inkl. Profi-Montage, Schutzhülle).
// Die Auswahl wird ZWISCHENGESPEICHERT und erst
// beim Klick auf "Weiter zur Kasse" auf den Warenkorb angewendet (kein
// Flackern, keine Round-Trips pro Klick). "Ohne Extras zur Kasse" verwirft die
// Auswahl und entfernt bestehende Extras (Garantie/Montage).
//
// Verknüpfung über versteckte Line-Item-Properties:
//   _warranty_for / _wty_group  – Garantie ↔ Gerät
//   _montage_for  / _mtg_group  – Montage  ↔ Displayschutz
//   _rv_addon                   – Herkunft für die Auswertung (Schutzglas/Case);
//                                 ein Shopify Flow liest das von der Bestellzeile
//                                 und setzt Order-Tags (Addon: Schutzglas / Case)
// Werden Gerät bzw. Folie aus dem Warenkorb entfernt, räumt cleanup() die
// zugehörige Garantie-/Montage-Zeile automatisch mit ab.
//
// Konfiguration (Pläne, Montage, Regeln, Texte, Geldformat) kommt aus
// snippets/revendo-cart-addons-modal.liquid (#rv-addons-config).
// Styles: assets/revendo-cart-addons.css (.rv-modal*).
// =====================================================================
(function () {
  'use strict';

  // ---- Config (aus Liquid: Metaobjekt-Pläne, Montage, Settings, i18n) -
  var _cfg = null;
  function cfg() {
    if (_cfg) return _cfg;
    _cfg = { strings: {}, warrantyPlans: [], montage: null, settings: {}, moneyFormat: 'CHF {{amount}}' };
    try {
      var node = document.getElementById('rv-addons-config');
      if (node) _cfg = Object.assign(_cfg, JSON.parse(node.textContent));
    } catch (e) { console.warn('[rv-addons] config', e); }
    return _cfg;
  }
  function s(key, fallback) {
    var st = cfg().strings || {};
    return st[key] != null ? st[key] : (fallback != null ? fallback : key);
  }
  function settingsCfg() { return cfg().settings || {}; }
  // Berechtigte Geräte-Kategorien als Shopify-Taxonomy-IDs (z. B. "el-4-8-5" = iPhone).
  function warrantyCategories() {
    var c = settingsCfg().warrantyCategories || [];
    return c.map(function (x) { return String(x).trim(); }).filter(Boolean);
  }
  // Trifft ein Plan auf eine Geräte-Kategorie zu? Leere Plan-Liste = alle Geräte.
  function planMatchesCategory(plan, categoryId) {
    var pc = (plan.categories || []).map(function (x) { return String(x).trim(); }).filter(Boolean);
    if (!pc.length) return true;
    return pc.indexOf(String(categoryId)) > -1;
  }

  // ---- Routes / Fetch ------------------------------------------------
  function r(key, fallback) {
    return (window.routes && window.routes[key]) ? window.routes[key] : fallback;
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function addItems(items) { return postJSON(r('cart_add_url', '/cart/add.js'), { items: items }); }
  function changeLine(key, qty) { return postJSON(r('cart_change_url', '/cart/change.js'), { id: key, quantity: qty }); }
  // Properties einer Zeile setzen. WICHTIG: /cart/change.js ERSETZT die Properties –
  // daher muss immer das komplette (gemergte) Objekt + die Menge mitgeschickt werden.
  function changeLineProps(key, properties, quantity) {
    var body = { id: key, properties: properties };
    if (quantity != null) body.quantity = quantity;
    return postJSON(r('cart_change_url', '/cart/change.js'), body);
  }
  // Ein LEERES properties-Objekt wird von /cart/change.js ignoriert (200, Zeile
  // unverändert). Die letzte Property einer Zeile liess sich darum nicht löschen –
  // eine verwaiste Gruppen-ID blieb stumm am Gerät stehen und ging so in die Bestellung.
  // In diesem Fall die alten Keys mit leerem Wert mitschicken; leer gilt überall als
  // "nicht gesetzt" (JS prüft auf truthy, Liquid auf `!= blank`).
  function writableProps(before, after) {
    if (Object.keys(after).length) return after;
    var blanked = {};
    Object.keys(before || {}).forEach(function (k) { blanked[k] = ''; });
    return Object.keys(blanked).length ? blanked : after;
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }); }

  // ---- Herkunft fuer die Auswertung ----------------------------------
  // Garantie und Montage sind eigene Produkttypen ("Garantie", "Dienstleistung")
  // und in Shopify Analytics darum von selbst als Modal-Umsatz erkennbar.
  // Schutzglas und Case gibt es auch auf der Produktseite – nur diese zwei
  // tragen darum _rv_addon auf der Zeile. Die Property bleibt auf der Bestellzeile;
  // ein Shopify Flow macht daraus Order-Tags. Kein Cart-Attribut noetig: wird das
  // Schutzglas vor dem Checkout entfernt, ist die Zeile weg und der Tag entsteht nicht.
  // Feste ASCII-Begriffe statt Locale-Strings: der Wert wird zum Order-Tag und
  // muss in allen vier Storefront-Sprachen derselbe und ohne Sonderzeichen sein.
  function addonProps(kind, extra) {
    var props = Object.assign({}, extra || {});
    props._rv_addon = kind;
    return props;
  }

  // Eindeutige Gruppen-ID pro Paar (auch bei mehreren Geräten/Folien eindeutig).
  function newGroup() {
    return 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }
  // Findet die Warenkorb-Zeile des Geräts (per Line-Key, Fallback per Variante – ohne Add-on-Zeilen).
  function findDeviceItem(cart, key, variantId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) { if (items[i].key === key) return items[i]; }
    for (var j = 0; j < items.length; j++) {
      var p = items[j].properties || {};
      if (String(items[j].variant_id) === String(variantId) && !p._warranty_for && !p._montage_for) return items[j];
    }
    return null;
  }

  // Setzt (group) oder entfernt (group = null) _wty_group auf der Geräte-Zeile und
  // PRÜFT das Ergebnis im zurückgegebenen Warenkorb – /cart/change.js antwortet mit dem
  // kompletten Warenkorb, die Prüfung kostet also keinen zusätzlichen Request.
  // `res.ok` allein genügt nicht: fetch rejected bei HTTP 4xx/5xx nicht, und ein 200
  // heisst noch nicht, dass die Property wirklich an der Zeile steht. Ohne diese Prüfung
  // ging die Verknüpfung stillschweigend verloren (Garantie-Zeile mit Gruppen-ID, Gerät
  // ohne -> ERP kann nicht zuordnen). /cart/change.js scheitert z. B., wenn der Line-Key
  // inzwischen ungültig ist, weil eine App, ein zweiter Tab oder der Shop-Cart-Sync den
  // Warenkorb verändert hat -> einmal mit frisch geholtem Key nachziehen.
  // Rückgabe false = Verknüpfung steht NICHT; der Aufrufer darf dann keine Garantie anlegen.
  function setDeviceGroup(deviceItem, deviceProps, group) {
    if (!deviceItem) return Promise.resolve(false);
    var variantId = deviceItem.variant_id;
    var target = group || null;
    function groupOf(item) { return ((item && item.properties) || {})._wty_group || null; }
    if ((deviceProps._wty_group || null) === target) return Promise.resolve(true);
    // Schreibt und liest das Ergebnis aus derselben Antwort zurück. Die Zeile bekommt
    // beim Property-Wechsel einen neuen Line-Key, darum per Varianten-ID nachsehen.
    function write(item, props) {
      var next = Object.assign({}, props);
      if (target) next._wty_group = target; else delete next._wty_group;
      return changeLineProps(item.key, writableProps(props, next), item.quantity)
        .then(function (res) { return res && res.ok ? res.json() : null; })
        .then(function (cart) {
          var line = cart ? findDeviceItem(cart, null, variantId) : null;
          return !!line && groupOf(line) === target;
        });
    }
    return write(deviceItem, deviceProps)
      .then(function (ok) {
        if (ok) return true;
        return getCart().then(function (fresh) {
          var again = findDeviceItem(fresh, deviceItem.key, variantId);
          return again ? write(again, again.properties || {}) : false;
        });
      })
      .catch(function (e) { console.warn('[rv-addons] setDeviceGroup', e); return false; });
  }

  var rvBusy = false, cleanupRunning = false;
  var rvModel = [];   // beim Öffnen aus dem Drawer gebautes Angebotsmodell
  var rvState = {};   // devKey -> { planIndex, folieSelected, montageSelected, caseSelected }

  // ---- Geld & Preisberechnung ----------------------------------------
  // Formatiert Beträge wie das Theme (shop.money_format, z. B. "74 CHF").
  // Die Tokens ohne Trennzeichen im Namen ("amount", "amount_no_decimals")
  // rendert Shopify bei CHF mit Apostroph, die anderen erzwingen ihr Zeichen.
  // Fehlt ein Token hier, faellt es still in den default-Zweig und das Modal
  // zeigt ein anderes Format als der Warenkorb – siehe
  // scripts/money-format-check.mjs.
  function formatMoney(cents) {
    var fmt = cfg().moneyFormat || 'CHF {{amount}}';
    function withDelimiters(num, precision, thousands, decimal) {
      if (isNaN(num) || num == null) return '0';
      var fixed = (num / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, "'", '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_apostrophe_separator': value = withDelimiters(cents, 0, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      default: value = withDelimiters(cents, 2, "'", '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  function round5(n) { return Math.round(n / 5) * 5; }
  // Marketing-Preis: auf 5 runden und -1 (=> Endung 4/9, z. B. 49, 54, 59),
  // anschliessend auf die Preisspanne der Festpreis-Varianten klammern.
  function planPrice(plan, unitCents) {
    var chf = unitCents / 100;
    var raw = Number(plan.base || 0) + (Number(plan.percent || 0) / 100) * chf;
    var p = round5(raw) - 1;
    if (p < plan.min) p = plan.min;
    if (p > plan.max) p = plan.max;
    return p;
  }
  function planVariantId(plan, price) {
    return (plan.variants && plan.variants[String(price)]) ? plan.variants[String(price)] : null;
  }

  // ---- Drawer-Zeilen lesen -------------------------------------------
  function drawer() { return document.querySelector('cart-drawer'); }
  function rows() {
    var d = drawer();
    return d ? Array.prototype.slice.call(d.querySelectorAll('.cart-item[data-rv-variant-id]')) : [];
  }
  function presentVariantIds() {
    var set = {};
    rows().forEach(function (row) { set[row.getAttribute('data-rv-variant-id')] = true; });
    return set;
  }
  function warrantyRowFor(deviceVid) {
    var d = drawer();
    return d ? d.querySelector('.cart-item[data-rv-warranty-for="' + deviceVid + '"]') : null;
  }
  // Aktiver Plan einer Geräte-Zeile. Da sich mehrere Pläne dasselbe Produkt teilen
  // können (z. B. "3 Jahre inkl. Akku" und "3 Jahre"), wird die Geräte-Kategorie
  // berücksichtigt, damit der für das Gerät gültige Plan gewählt wird.
  function currentPlanIndex(deviceVid, category) {
    var wRow = warrantyRowFor(deviceVid);
    if (!wRow) return -1;
    var wvid = String(wRow.getAttribute('data-rv-variant-id'));
    var plans = cfg().warrantyPlans || [];
    for (var i = 0; i < plans.length; i++) {
      if (category != null && !planMatchesCategory(plans[i], category)) continue;
      var vars = plans[i].variants || {};
      for (var k in vars) { if (String(vars[k]) === wvid) return i; }
    }
    return -1;
  }

  // ---- Angebotsmodell aus dem Drawer aufbauen ------------------------
  function isOutletRow(row) { return row.getAttribute('data-rv-outlet') === '1'; }
  function devKey(dev) { return dev.lineKey || dev.variantId; }
  function buildModel() {
    var present = presentVariantIds();
    var sc = settingsCfg();
    var cats = warrantyCategories();
    var plans = cfg().warrantyPlans || [];
    var warrantyOn = sc.warrantyEnabled !== false && plans.length > 0;
    var accessoryOn = sc.accessoryEnabled !== false;
    var caseOn = sc.caseEnabled !== false;
    // Outlet-Geräte (data-rv-outlet, gesetzt in revendo-cart-addons-item.liquid,
    // nur wenn rv_outlet_hide aktiv ist): eigene Garantie-Regelung. Liegt eines
    // im Warenkorb, entfällt das Modal ganz – bewusst auch Zubehör und Mischwarenkorb.
    var cartRows = rows();
    if (cartRows.some(isOutletRow)) return [];
    var devices = [];
    cartRows.forEach(function (row) {
      var category = row.getAttribute('data-rv-category') || '';
      var categoryAllowed = cats.indexOf(category) > -1;
      // Pro Gerät nur die Pläne, die für seine Kategorie gelten (iPhone vs. übrige).
      var applicablePlans = [];
      if (warrantyOn && categoryAllowed) {
        plans.forEach(function (plan, i) {
          if (planMatchesCategory(plan, category)) applicablePlans.push({ plan: plan, index: i });
        });
      }
      var folieVid = row.getAttribute('data-rv-folie-variant-id');
      var folieOffer = accessoryOn && folieVid && !present[folieVid];
      var caseVid = row.getAttribute('data-rv-case-variant-id');
      var caseOffer = caseOn && caseVid && !present[caseVid];
      var warrantyApplicable = warrantyOn && categoryAllowed && applicablePlans.length > 0;
      if (!warrantyApplicable && !folieOffer && !caseOffer) return;

      var vid = row.getAttribute('data-rv-variant-id');
      var unit = Number(row.getAttribute('data-rv-unit-price') || row.getAttribute('data-rv-line-price') || 0);
      var dev = {
        variantId: vid,
        lineKey: row.getAttribute('data-rv-line-key') || '',
        title: row.getAttribute('data-rv-title') || '',
        image: row.getAttribute('data-rv-image') || '',
        unit: unit,
        warranty: warrantyApplicable,
        plans: applicablePlans,
        planIndex: currentPlanIndex(vid, category),
        folie: null,
        huelle: null
      };
      if (folieOffer) {
        dev.folie = {
          variantId: folieVid,
          title: row.getAttribute('data-rv-folie-title') || '',
          image: row.getAttribute('data-rv-folie-image') || '',
          price: Number(row.getAttribute('data-rv-folie-price') || 0),
          montage: row.getAttribute('data-rv-folie-montage') === '1'
        };
      }
      if (caseOffer) {
        dev.huelle = {
          variantId: caseVid,
          title: row.getAttribute('data-rv-case-title') || '',
          image: row.getAttribute('data-rv-case-image') || '',
          price: Number(row.getAttribute('data-rv-case-price') || 0)
        };
      }
      devices.push(dev);
    });
    return devices;
  }
  // Modal nur zeigen, wenn es echtes Angebot gibt (Garantie noch wählbar ODER ein
  // noch nicht im Warenkorb liegendes Zubehör – Displayschutz oder Hülle).
  function hasOffers(devices) {
    return devices.some(function (d) { return (d.warranty && d.planIndex < 0) || d.folie || d.huelle; });
  }
  // Auswahl-State pro Gerät aus dem aktuellen Warenkorb vorbelegen.
  function initState(devices) {
    rvState = {};
    devices.forEach(function (dev) {
      rvState[devKey(dev)] = {
        planIndex: dev.planIndex,   // ggf. bereits gewählte Garantie
        folieSelected: false,       // Zubehör wird nur angeboten, wenn nicht im Cart
        montageSelected: false,
        caseSelected: false
      };
    });
  }

  // ---- DOM-Helfer -----------------------------------------------------
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function thumb(src, cls, alt) {
    if (src) {
      var img = document.createElement('img');
      img.className = cls;
      img.src = src;
      img.alt = alt || '';
      img.loading = 'lazy';
      return img;
    }
    return el('div', cls);
  }
  function priceEl(cents, muted) {
    var span = el('span', 'rv-opt__price price' + (muted ? ' is-muted' : ''));
    span.textContent = muted ? s('included', 'inkl.') : formatMoney(cents);
    return span;
  }

  // ---- Footer-Summe ---------------------------------------------------
  function extrasTotalCents() {
    var total = 0;
    rvModel.forEach(function (dev) {
      var st = rvState[devKey(dev)] || {};
      if (dev.warranty && st.planIndex != null && st.planIndex >= 0) {
        var plan = (cfg().warrantyPlans || [])[st.planIndex];
        if (plan) total += planPrice(plan, dev.unit) * 100;
      }
      if (dev.folie && st.folieSelected) {
        total += dev.folie.price;
        var montage = cfg().montage;
        if (st.montageSelected && montage) total += montage.price;
      }
      if (dev.huelle && st.caseSelected) total += dev.huelle.price;
    });
    return total;
  }
  function updateSummary() {
    var box = document.getElementById('rv-extras-summary');
    if (!box) return;
    var cents = extrasTotalCents();
    var amount = box.querySelector('.rv-summary__amount');
    if (amount) amount.textContent = formatMoney(cents);
    box.hidden = cents <= 0;
  }

  // ---- Modal rendern (rein lokal, keine Cart-Calls) ------------------
  // Vorteils-Bullets eines Plans. Bewusst nur beim GEWÄHLTEN Plan sichtbar: die
  // Details kommen genau im Entscheidungsmoment, das Modal bleibt sonst kompakt
  // (mobil ist es ein Bottom-Sheet).
  function benefitsList(plan, isActive) {
    var items = (plan && plan.benefits ? plan.benefits : [])
      .map(function (x) { return String(x).trim(); })
      .filter(Boolean);
    if (!items.length) return null;
    var ul = el('ul', 'rv-opt__benefits');
    ul.hidden = !isActive;
    items.forEach(function (text) { ul.appendChild(el('li', null, text)); });
    return ul;
  }

  // Untertitel. Mehrteilige Angaben ("Statt 1 Jahr · 50 % auf eine Akku-Reparatur")
  // werden zu Bullets: braucht praktisch gleich viel Platz wie die umbrechende
  // Zeile, ist aber schneller zu erfassen. Einteilige Saetze bleiben Fliesstext.
  function subtitleEl(text) {
    var parts = String(text).split('·').map(function (x) { return x.trim(); }).filter(Boolean);
    if (parts.length < 2) return el('div', 'rv-opt__sub', text);
    var ul = el('ul', 'rv-opt__sub rv-opt__sub--list');
    parts.forEach(function (p) { ul.appendChild(el('li', null, p)); });
    return ul;
  }

  function warrantyOption(dev, plan, index, isActive, isRecommended) {
    var btn = el('button', 'rv-opt' + (isActive ? ' is-active' : ''));
    btn.type = 'button';
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
    btn.appendChild(el('span', 'rv-opt__mark'));

    var main = el('div', 'rv-opt__main');
    var title = el('div', 'rv-opt__title', plan ? plan.title : s('warranty_none', 'Standard-Garantie'));
    if (plan && isRecommended) title.appendChild(el('span', 'rv-badge', s('recommended', 'Empfohlen')));
    main.appendChild(title);
    var sub = plan ? (plan.subtitle || '') : s('warranty_none_sub', '');
    if (sub) main.appendChild(subtitleEl(sub));
    var benefits = benefitsList(plan, isActive);
    if (benefits) main.appendChild(benefits);
    btn.appendChild(main);
    btn.appendChild(plan ? priceEl(planPrice(plan, dev.unit) * 100, false) : priceEl(0, true));

    btn.addEventListener('click', function () {
      var group = btn.parentNode;
      Array.prototype.forEach.call(group.querySelectorAll('.rv-opt'), function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-checked', 'false');
      });
      // Bullets der ganzen Gruppe zuklappen, nur die der aktiven Option zeigen.
      Array.prototype.forEach.call(group.querySelectorAll('.rv-opt__benefits'), function (l) {
        l.hidden = true;
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');
      if (benefits) benefits.hidden = false;
      rvState[devKey(dev)].planIndex = plan ? index : -1;
      updateSummary();
    });
    return btn;
  }

  function warrantyGroup(dev) {
    var grp = el('div', 'rv-group');
    grp.appendChild(el('div', 'rv-group__label', s('warranty_section_title', 'Garantieverlängerung')));
    var opts = el('div', 'rv-opts');
    opts.setAttribute('role', 'radiogroup');
    opts.setAttribute('aria-label', s('warranty_section_title', 'Garantieverlängerung'));
    var active = rvState[devKey(dev)].planIndex;
    opts.appendChild(warrantyOption(dev, null, -1, active < 0, false));
    (dev.plans || []).forEach(function (entry, pos) {
      opts.appendChild(warrantyOption(dev, entry.plan, entry.index, active === entry.index, pos === 0));
    });
    grp.appendChild(opts);
    return grp;
  }

  // Eine Zubehör-Checkbox-Zeile (Displayschutz oder Hülle). `stateKey` zeigt auf das
  // Feld in rvState, `onToggle` erlaubt der Folien-Zeile, die Montage mitzuräumen.
  function accessoryRow(dev, offer, stateKey, onToggle) {
    var st = rvState[devKey(dev)];
    var opt = el('button', 'rv-opt rv-opt--check' + (st[stateKey] ? ' is-active' : ''));
    opt.type = 'button';
    opt.setAttribute('role', 'checkbox');
    opt.setAttribute('aria-checked', st[stateKey] ? 'true' : 'false');
    opt.appendChild(el('span', 'rv-opt__mark'));
    if (offer.image) opt.appendChild(thumb(offer.image, 'rv-opt__img', offer.title));
    var main = el('div', 'rv-opt__main');
    var title = el('div', 'rv-opt__title', offer.title);
    // CSS kappt den Titel nach zwei Zeilen (siehe .rv-opt--check .rv-opt__title),
    // hier der volle Name als Tooltip. Im DOM steht er ohnehin komplett, also
    // lesen Screenreader ihn unverkuerzt.
    title.title = offer.title;
    main.appendChild(title);
    opt.appendChild(main);
    opt.appendChild(priceEl(offer.price, false));

    opt.addEventListener('click', function () {
      st[stateKey] = !st[stateKey];
      opt.classList.toggle('is-active', st[stateKey]);
      opt.setAttribute('aria-checked', st[stateKey] ? 'true' : 'false');
      if (onToggle) onToggle(st[stateKey], opt);
      updateSummary();
    });
    return opt;
  }

  // Displayschutz + Hülle in EINER Box, damit das Modal zweispaltig bleibt
  // (Garantie | Zubehör) und der Montage-Schalter direkt am Glas hängt.
  function accessoryGroup(dev) {
    var grp = el('div', 'rv-group');
    grp.appendChild(el('div', 'rv-group__label', s('accessory_section_title', 'Zubehör')));

    var st = rvState[devKey(dev)];
    var swInput = null;

    if (dev.folie) {
      var folieOpt = accessoryRow(dev, dev.folie, 'folieSelected', function (checked) {
        // Folie abgewählt → Montage kann nicht allein bestehen.
        if (!checked && swInput) { swInput.checked = false; st.montageSelected = false; }
      });
      grp.appendChild(folieOpt);

      // Montage-Schalter: bewusst IMMER sichtbar (Verkaufsargument), auch bevor die
      // Folie gewählt ist. Aktiviert man die Montage, wird die Folie automatisch
      // mitgewählt (Montage setzt das Glas voraus) – ein Tap für „Glas + Montage".
      var montage = cfg().montage;
      if (dev.folie.montage && montage && montage.variantId) {
        var sw = el('label', 'rv-switch');
        swInput = document.createElement('input');
        swInput.type = 'checkbox';
        swInput.checked = !!st.montageSelected;
        var track = el('span', 'rv-switch__track');
        track.appendChild(el('span', 'rv-switch__thumb'));
        sw.appendChild(swInput);
        sw.appendChild(track);
        var txt = el('div', 'rv-switch__text');
        txt.appendChild(el('span', 'rv-switch__label', s('with_montage', 'Profi-Montage dazu')));
        // Rueckgabe-Ausschluss in die Hinweiszeile integriert (kurz), statt als eigener
        // Block darunter: der Hinweis ist so immer sichtbar, ohne das Modal zu stoeren.
        var hint = '+ ' + formatMoney(montage.price) + ' · ' + s('montage_note', '');
        var noReturn = s('montage_no_return_short', '');
        if (noReturn) hint += ' · ' + noReturn;
        txt.appendChild(el('span', 'rv-switch__hint', hint));
        sw.appendChild(txt);
        swInput.addEventListener('change', function () {
          st.montageSelected = swInput.checked;
          if (swInput.checked && !st.folieSelected) {
            st.folieSelected = true;
            folieOpt.classList.add('is-active');
            folieOpt.setAttribute('aria-checked', 'true');
          }
          updateSummary();
        });
        grp.appendChild(sw);
      }
    }

    if (dev.huelle) grp.appendChild(accessoryRow(dev, dev.huelle, 'caseSelected', null));

    return grp;
  }

  function renderModal() {
    var modal = document.getElementById('rv-addons-modal');
    if (!modal) return;
    var content = modal.querySelector('#rv-addons-content');
    content.innerHTML = '';
    var twoCol = false;

    rvModel.forEach(function (dev) {
      var card = el('div', 'rv-card');

      var head = el('div', 'rv-dev');
      head.appendChild(thumb(dev.image, 'rv-dev__img', dev.title));
      var meta = el('div', 'rv-dev__meta');
      meta.appendChild(el('div', 'rv-dev__title', dev.title));
      meta.appendChild(el('div', 'rv-dev__price', formatMoney(dev.unit)));
      head.appendChild(meta);
      card.appendChild(head);

      var cols = el('div', 'rv-cols');
      var count = 0;
      if (dev.warranty && dev.plans.length) { cols.appendChild(warrantyGroup(dev)); count++; }
      if (dev.folie || dev.huelle) { cols.appendChild(accessoryGroup(dev)); count++; }
      if (count === 1) cols.classList.add('is-single'); else twoCol = true;
      card.appendChild(cols);
      content.appendChild(card);
    });

    var dlg = modal.querySelector('.rv-modal__dialog');
    if (dlg) dlg.classList.toggle('rv-wide', twoCol);
    updateSummary();
  }

  // ---- Anwenden + Checkout (deferred) --------------------------------
  function footerBusy(state) {
    var m = document.getElementById('rv-addons-modal');
    if (m) m.classList.toggle('is-busy', state);
    rvBusy = state;
  }
  // Locale-aware Checkout-URL: ein hartes '/checkout' verlässt auf /en- und
  // /fr-Seiten den Sprachkontext des Käufers.
  function checkout() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    window.location.href = root + 'checkout';
  }

  // Garantie für ein Gerät anwenden (Plan setzen / wechseln / entfernen).
  function warrantyTransaction(cart, dev, planIndex) {
    var plans = cfg().warrantyPlans || [];
    var deviceItem = findDeviceItem(cart, dev.lineKey, dev.variantId);
    var deviceQty = deviceItem ? deviceItem.quantity : null;
    var deviceProps = deviceItem ? Object.assign({}, deviceItem.properties || {}) : {};
    var existing = null;
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (String(p._warranty_for) === String(dev.variantId)) existing = it;
    });
    var chain = existing ? changeLine(existing.key, 0) : Promise.resolve();
    return chain.then(function () {
      if (planIndex == null || planIndex < 0) {
        if (deviceItem && deviceProps._wty_group) {
          return setDeviceGroup(deviceItem, deviceProps, null);
        }
        return null;
      }
      var plan = plans[planIndex];
      var vid = planVariantId(plan, planPrice(plan, dev.unit));
      if (!vid) return null;
      var group = deviceProps._wty_group || newGroup();
      var props = {};
      props._warranty_for = dev.variantId;
      props._wty_group = group;
      props[s('warranty_prop_name', 'Garantie')] = plan.propertyValue || plan.title;
      // Menge der Garantie = Menge des Geräts (z. B. 2 Geräte → 2 Garantien).
      var wtyQty = deviceQty || 1;
      // Gruppen-ID ZUERST aufs Gerät, danach die Garantie-Zeile, und nur wenn das Gerät
      // wirklich markiert ist. Steht die Markierung nicht, wird KEINE Garantie angelegt:
      // sonst entsteht eine Garantie-Zeile ohne Partner (die das ERP nicht zuordnen kann)
      // – oder, wenn das Gerät gar nicht mehr im Warenkorb liegt (veralteter Drawer,
      // zweiter Tab, Shop-Cart-Sync), eine Bestellung nur über die Garantie.
      // Die Garantie-Zeile trägt zusätzlich _warranty_for = Varianten-ID des Geräts
      // als Fallback-Verknüpfung, beides in EINEM /cart/add.js – kann nicht halb gelingen.
      return setDeviceGroup(deviceItem, deviceProps, group).then(function (tagged) {
        if (!tagged) return null;
        return addItems([{ id: Number(vid), quantity: wtyQty, properties: props }])
          .then(function (res) {
            if (res && res.ok) return res;
            // Garantie liess sich nicht anlegen (z. B. Plan-Variante nicht verfügbar):
            // Markierung am Gerät zurücknehmen, sonst geht das Gerät mit verwaister
            // Gruppen-ID in die Bestellung – cleanup() kommt vor dem Redirect nicht dran.
            return getCart().then(function (fresh) {
              var d = findDeviceItem(fresh, null, dev.variantId);
              return d ? setDeviceGroup(d, d.properties || {}, null) : null;
            });
          });
      });
    });
  }

  // Displayschutz (+ optional Montage) hinzufügen. Folie + Montage teilen sich
  // eine _mtg_group, damit cleanup() die Montage beim Entfernen der Folie mitnimmt.
  function folieTransaction(dev, withMontage) {
    if (!dev.folie) return Promise.resolve();
    var montage = cfg().montage;
    var doMontage = withMontage && montage && montage.variantId;
    var group = newGroup();
    var folieItem = { id: Number(dev.folie.variantId), quantity: 1 };
    folieItem.properties = addonProps('Schutzglas', doMontage ? { _mtg_group: group } : null);
    var items = [folieItem];
    if (doMontage) {
      var mp = {};
      mp._montage_for = dev.folie.variantId;
      mp._mtg_group = group;
      mp[s('montage_prop_name', 'Service')] = s('montage_prop_value', 'Montage');
      items.push({ id: Number(montage.variantId), quantity: 1, properties: mp });
    }
    return addItems(items);
  }

  // Schutzhülle hinzufügen. Bewusst OHNE _*_for/_*_group-Properties: die Hülle ist
  // ein eigenständiges Produkt, das ohne das Gerät im Warenkorb sinnvoll bleibt –
  // cleanup() muss sie also nicht abräumen (wie die Folie ohne Montage).
  function caseTransaction(dev) {
    if (!dev.huelle) return Promise.resolve();
    return addItems([{ id: Number(dev.huelle.variantId), quantity: 1, properties: addonProps('Case') }]);
  }

  // primary: Auswahl anwenden. secondary (removeAll): bestehende Extras entfernen.
  function applyAndCheckout(removeAll) {
    footerBusy(true);
    var primaryBtn = document.querySelector('[data-rv-proceed]');
    if (primaryBtn) primaryBtn.classList.add('is-loading');
    getCart()
      .then(function (cart) {
        var chain = Promise.resolve();
        if (removeAll) {
          (cart.items || []).forEach(function (it) {
            var p = it.properties || {};
            if (p._warranty_for || p._montage_for) {
              chain = chain.then(function () { return changeLine(it.key, 0); });
            }
          });
          // Verwaiste Gruppen-Markierungen an Host-Zeilen (Gerät/Folie) entfernen.
          (cart.items || []).forEach(function (it) {
            var p = it.properties || {};
            if (!p._warranty_for && !p._montage_for && (p._wty_group || p._mtg_group)) {
              var cleaned = Object.assign({}, p);
              delete cleaned._wty_group;
              delete cleaned._mtg_group;
              chain = chain.then(function () { return changeLineProps(it.key, writableProps(p, cleaned), it.quantity); });
            }
          });
        } else {
          rvModel.forEach(function (dev) {
            var st = rvState[devKey(dev)] || {};
            if (dev.warranty && st.planIndex !== dev.planIndex) {
              chain = chain.then(function () { return warrantyTransaction(cart, dev, st.planIndex); });
            }
            if (dev.folie && st.folieSelected) {
              chain = chain.then(function () { return folieTransaction(dev, st.montageSelected); });
            }
            if (dev.huelle && st.caseSelected) {
              chain = chain.then(function () { return caseTransaction(dev); });
            }
          });
        }
        return chain;
      })
      .then(checkout)
      .catch(function (e) { console.warn('[rv-addons] apply', e); checkout(); });
  }

  // ---- Öffnen / Schliessen -------------------------------------------
  // Hintergrund komplett blockieren: Modal an <body> hängen und alle übrigen
  // Body-Kinder auf `inert` setzen (kein Klick/Fokus/Scroll dahinter).
  var rvLastFocused = null;
  var rvInerted = [];
  function setBackgroundInert(on) {
    var modal = document.getElementById('rv-addons-modal');
    if (!modal) return;
    if (on) {
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      rvInerted = [];
      Array.prototype.forEach.call(document.body.children, function (c) {
        if (c === modal || c.hasAttribute('inert')) return;
        c.setAttribute('inert', '');
        c.setAttribute('aria-hidden', 'true');
        rvInerted.push(c);
      });
    } else {
      rvInerted.forEach(function (c) { c.removeAttribute('inert'); c.removeAttribute('aria-hidden'); });
      rvInerted = [];
    }
  }
  function focusables(container) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(container.querySelectorAll(sel)).filter(function (n) {
      return n.offsetParent !== null || n === document.activeElement;
    });
  }
  function openModal() {
    var m = document.getElementById('rv-addons-modal');
    if (!m) return;
    // Defensiv: evtl. von einem früheren Checkout hängengebliebenen Zustand lösen.
    footerBusy(false);
    Array.prototype.forEach.call(m.querySelectorAll('.is-loading'), function (x) {
      x.classList.remove('is-loading');
    });
    rvLastFocused = document.activeElement;
    var d = drawer();
    if (d && typeof d.close === 'function') d.close(); // Side-Cart schliessen
    rvModel = buildModel();
    initState(rvModel);
    renderModal();
    m.hidden = false;
    document.body.classList.add('overflow-hidden');
    setBackgroundInert(true);
    setTimeout(function () {
      var dlg = m.querySelector('.rv-modal__dialog');
      var target = m.querySelector('.rv-opt') || (dlg ? focusables(dlg)[0] : null);
      if (target) target.focus();
    }, 40);
  }
  function hideModal() {
    var m = document.getElementById('rv-addons-modal');
    if (!m) return;
    setBackgroundInert(false);
    m.hidden = true;
    // Vollständiger Reset: "busy"-Zustand und Lade-Spinner zurücksetzen, damit ein
    // wieder geöffnetes (oder per bfcache wiederhergestelltes) Modal nutzbar ist.
    m.classList.remove('is-busy');
    rvBusy = false;
    Array.prototype.forEach.call(m.querySelectorAll('.is-loading'), function (x) {
      x.classList.remove('is-loading');
    });
    document.body.classList.remove('overflow-hidden');
    if (rvLastFocused && typeof rvLastFocused.focus === 'function') {
      try { rvLastFocused.focus(); } catch (e) { /* noop */ }
    }
  }
  // Abbrechen (X / Overlay / Esc): nichts anwenden, Side-Cart wieder öffnen.
  function dismissModal() {
    hideModal();
    var d = drawer();
    if (d && typeof d.open === 'function') d.open();
  }

  // ---- Events --------------------------------------------------------
  // Checkout-Button im Side-Cart abfangen (Capture-Phase vor dem Submit)
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout') : null;
    if (!checkoutBtn) return;
    var devices = buildModel();
    if (!hasOffers(devices)) return; // nichts anzubieten → normaler Checkout
    e.preventDefault();
    e.stopPropagation();
    openModal();
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-rv-close]')) { dismissModal(); return; }
    if (e.target.closest('[data-rv-skip]')) { if (!rvBusy) applyAndCheckout(true); return; }
    if (e.target.closest('[data-rv-proceed]')) { if (!rvBusy) applyAndCheckout(false); return; }
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      var m = document.getElementById('rv-addons-modal');
      if (m && !m.hidden) dismissModal();
    }
  });
  // Pfeiltasten innerhalb einer Optionsgruppe (Radiogroup-Navigation).
  document.addEventListener('keydown', function (e) {
    var m = document.getElementById('rv-addons-modal');
    if (!m || m.hidden) return;
    var active = document.activeElement;
    if (/^Arrow(Up|Down|Left|Right)$/.test(e.key) && active && active.classList && active.classList.contains('rv-opt')) {
      var group = active.closest('.rv-opts');
      if (!group) return;
      var items = Array.prototype.slice.call(group.querySelectorAll('.rv-opt'));
      var idx = items.indexOf(active);
      if (idx > -1) {
        e.preventDefault();
        var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        items[(idx + dir + items.length) % items.length].focus();
      }
    }
  });

  // ---- Aufräumen: verwaiste Garantie-/Montage-Zeilen entfernen -------
  function cleanup() {
    if (rvBusy || cleanupRunning) return;
    cleanupRunning = true;
    getCart()
      .then(function (cart) {
        // Zwischenzeitlich hat der Modal-Apply begonnen: dessen Warenkorb-Umbau
        // (alte Garantie entfernen → neue hinzufügen) sieht von hier aus wie eine
        // verwaiste Gruppen-Markierung am Gerät. Snapshot verwerfen.
        if (rvBusy) return null;
        var present = {};
        var liveWty = {};   // _wty_group, die eine aktive Garantie-Zeile haben
        var liveMtg = {};   // _mtg_group, die eine aktive Montage-Zeile haben
        var devQtyByWtyGroup = {}; // Gerätemenge je Garantie-Gruppe (für Mengen-Kopplung)
        cart.items.forEach(function (it) {
          present[String(it.variant_id)] = true;
          var p = it.properties || {};
          if (p._warranty_for && p._wty_group) liveWty[p._wty_group] = true;
          if (p._montage_for && p._mtg_group) liveMtg[p._mtg_group] = true;
          // Host-Gerätezeile (kein Add-on) mit Garantie-Gruppe → Menge merken.
          if (!p._warranty_for && !p._montage_for && p._wty_group) devQtyByWtyGroup[p._wty_group] = it.quantity;
        });
        var ops = [];
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          // Verwaiste Garantie-/Montage-Zeile (Gerät/Folie entfernt) → löschen.
          if ((p._warranty_for && !present[String(p._warranty_for)]) ||
              (p._montage_for && !present[String(p._montage_for)])) {
            ops.push(function () { return changeLine(it.key, 0); });
            return;
          }
          // Aktive Garantie-Zeile → Menge an die Gerätemenge koppeln (z. B. Gerät 2 → Garantie 2).
          if (p._warranty_for && p._wty_group) {
            var devQty = devQtyByWtyGroup[p._wty_group];
            if (devQty != null && devQty !== it.quantity) {
              ops.push((function (key, qty) { return function () { return changeLine(key, qty); }; })(it.key, devQty));
            }
            return;
          }
          // Verwaiste Gruppen-Markierung an einer Host-Zeile (Gerät/Folie) → bereinigen.
          if (!p._warranty_for && !p._montage_for) {
            var stale = (p._wty_group && !liveWty[p._wty_group]) || (p._mtg_group && !liveMtg[p._mtg_group]);
            if (stale) {
              var cleaned = Object.assign({}, p);
              if (p._wty_group && !liveWty[p._wty_group]) delete cleaned._wty_group;
              if (p._mtg_group && !liveMtg[p._mtg_group]) delete cleaned._mtg_group;
              ops.push(function () { return changeLineProps(it.key, writableProps(p, cleaned), it.quantity); });
            }
          }
        });
        if (!ops.length) return null;
        return ops.reduce(function (acc, op) { return acc.then(op); }, Promise.resolve())
          .then(function () { return refreshDrawer(); });
      })
      .catch(function (e) { console.warn('[rv-addons] cleanup', e); })
      .then(function () { cleanupRunning = false; });
  }

  // ---- Drawer neu rendern (für cleanup) ------------------------------
  function refreshDrawer() {
    var base = r('cart_url', '/cart');
    return fetch(base + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var clean = text.replace(/<template\b[^>]*>|<\/template>/g, '');
        var html = new DOMParser().parseFromString(clean, 'text/html');
        var src = html.querySelector('#CartDrawer');
        var dst = document.getElementById('CartDrawer');
        if (src && dst) dst.innerHTML = src.innerHTML;
        var wrap = drawer();
        if (wrap) {
          wrap.classList.remove('is-empty');
          var inner = wrap.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          var overlay = wrap.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof wrap.close === 'function') overlay.addEventListener('click', wrap.close.bind(wrap));
        }
        if (typeof window.loadTemplateContent === 'function' && wrap) {
          try { window.loadTemplateContent(wrap); } catch (e) { /* noop */ }
        }
        return fetch(base + '?section_id=cart-icon-bubble');
      })
      .then(function (res) { return res ? res.text() : null; })
      .then(function (text) {
        if (text == null) return;
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var clean = text.replace(/<template\b[^>]*>|<\/template>/g, '');
        var doc = new DOMParser().parseFromString(clean, 'text/html');
        var section = doc.querySelector('.shopify-section');
        bubble.innerHTML = section ? section.innerHTML : doc.body.innerHTML;
      })
      .catch(function (e) { console.warn('[rv-addons] refresh', e); });
  }

  ['cart-update', 'cart-remove', 'cart-add'].forEach(function (ev) {
    document.addEventListener(ev, function () { cleanup(); });
  });

  // Zurück aus dem Checkout: Die Seite wird per bfcache im exakten Zustand vor dem
  // Redirect wiederhergestellt – inkl. offenem "busy"-Modal (Button dreht, nicht
  // schliessbar) und veralteter Warenkorb-Anzeige. Daher Modal sauber schliessen
  // und Drawer + Header-Bubble auffrischen, damit die Mengen wieder stimmen.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    hideModal();
    refreshDrawer();
  });
})();
// END Revendo: Checkout-Add-ons-Modal
